<template>
    <div class='txxsc box' v-if='!isLoading'>
        <el-table
        ref="table"
        border
        :data="tableData"
        style="width: 100%"
        >
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="companyName" label="投标单位名称" show-overflow-tooltip min-width="200"></el-table-column>
            <el-table-column prop="tenderQuotation" label="投标报价" show-overflow-tooltip width="120"></el-table-column>
            <el-table-column prop="maximumBiddingPrice" label="最高投标限价" show-overflow-tooltip width="140"></el-table-column>
            <el-table-column prop="bidEvaluationBasePrice" label="评标标底价" show-overflow-tooltip width="110"></el-table-column>
            <el-table-column prop="commercialBidScore" label="商务标得分" show-overflow-tooltip width="110"></el-table-column>
            <el-table-column prop="rank" label="排名" show-overflow-tooltip width="70"></el-table-column>
            <el-table-column prop="complianceReview" label="符合性审查" width="120">
                <template slot-scope="scope">
                    <template>{{scope.row.complianceReview==1?"通过":scope.row.complianceReview==2?"不通过":"未审查"}}</template>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div v-else class='loading'>
        <p>正在进行有效性审查，请耐心等待...</p>
        <div id="colorfulPulse">
            <span class='item-1'></span>
            <span class='item-2'></span>
            <span class='item-3'></span>
            <span class='item-4'></span>
            <span class='item-5'></span>
            <span class='item-6'></span>
            <span class='item-7'></span>
        </div>
    </div>
</template>
<script>
    export default {
        name:'tbzgfhxsc',
        props:['djlcId'],
        data(){
            return{
                tableData:[],
                isLoading:true
            }
        },
        methods:{
            getData(){
                let para={
                    djlcId:this.djlcId,
                    currentPage:1,
                    pageSize:10,
                }
                this.$api.getListInfoByKbxmId(para).then(res=>{
                    if(res.data.meta.success){
                        this.tableData=res.data.data.page.list;
                        this.isLoading=false
                    }else{
                        this.$message({
                            type:'error',
                            message:res.data.meta.message
                        })
                        this.isLoading=false
                    }
                }).catch(()=>{})
            },
        },
        mounted(){
            this.getData();
        }
    }
</script>    